export { default } from "./DxTable";
